import React from 'react';
import { useCurrentUser, useGate } from '@mp/hooks';
import useSocialProofMarketActivity, {
  SocialProofVariant,
} from '../../hooks/useSocialProofMarketActivity';

import HighVolume from './HighVolume';
import LowVolume from './LowVolume';
import NoJobs from './NoJobs';
import { gateNames } from '@mp/constants';

export const SocialProofBanner: React.FC = () => {
  const { value: showBanner } = useGate(gateNames.fg_social_proof_banner);
  if (!showBanner) {
    return null;
  }

  const { currentUser, isAgency, isSaas } = useCurrentUser();
  if (isAgency || isSaas) {
    return null;
  }
  const proId = currentUser?.id;
  const marketIds = currentUser?.professional?.markets?.map((m) => m.id) ?? [];
  const positionIds = currentUser?.professional?.positions?.map((p) => p.id) ?? [];

  if (!proId || marketIds.length === 0 || positionIds.length === 0) {
    return null;
  }

  const { isLoading, error, variant, shiftsCount, minPay, maxPay, availableJobsCount } =
    useSocialProofMarketActivity({
      marketIds,
      positionIds,
      currentUserId: proId,
    });

  if (isLoading || error) {
    return null;
  }

  if (variant === undefined || shiftsCount === undefined || availableJobsCount === undefined) {
    return null;
  }

  let key: SocialProofVariant = variant;

  if (availableJobsCount === 0) {
    key = shiftsCount > 0 ? 'low-volume' : 'no-jobs';
  }

  const map: Record<SocialProofVariant, JSX.Element> = {
    'high-volume': <HighVolume shiftsCount={shiftsCount} minPay={minPay!} maxPay={maxPay!} />,
    'low-volume': <LowVolume />,
    'no-jobs': <NoJobs />,
  };

  return map[key];
};
